import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = { minimal: { type: Array, default: [] } }

  selectAll() {
    this.checkboxTargets.forEach((cb) => (cb.checked = true))
  }

  selectMinimal() {
    const minimalCodes = this.minimalValue
    this.checkboxTargets.forEach((cb) => {
      cb.checked = minimalCodes.includes(cb.value)
    })
  }
}
